import { BUNDLE_SMALL_NAME } from "../normalMode/BundleResourceConfig";

/**
 * 文件类
 */
export namespace FileKind {
    
    /** 资源解析 */
    export enum ResParseType {
        /** 一条数据 */
        ITEM = '#',
        /** 一个字段 */
        SUB_ITEM = '&',
        SUB_ITEM2 = '_',
        /** 大段数据 */
        BIG_ITEM = '\r\n',
        /** 大段数据 */
        BIG_ITEM2 = '\n',
    }

     /**
     * 数据存储key
     */
     export enum SaveLocalDataKey {
        MILITARY_OFFICER_DATA = 'MILITARY_OFFICER_DATA',
        MILITARY_NEW_OFFICER_DATA = 'MILITARY_NEW_OFFICER_DATA',
        MILITARY_CITY_DATA = 'MILITARY_CITY_DATA',
        MILITARY_NEW_CITY_DATA = 'MILITARY_NEW_CITY_DATA',
        MATCH_MIAI_DATA = 'MATCH_MIAI_DATA',
        WIFE_DATA = 'WIFE_DATA',
        CHILD_DATA = 'CHILD_DATA',
        MANSION_BUILD_DATA = 'MANSION_BUILD_DATA',
        MANSION_DATA = 'MANSION_DATA',
        THRU_TIME_DATA = 'THRU_TIME_DATA',
        SHIP_DATA = 'SHIP_DATA',
     }

    /** 预制体文件信息 */
    export class PrefabFileInfo {
        filePath: string = '';
        bundle: BUNDLE_SMALL_NAME;
        constructor(filePath: string, bundle: BUNDLE_SMALL_NAME) {
            this.filePath = filePath;
            this.bundle = bundle;
        }
    }

    /** 预制体路径 */
    export const PrefabFilePath = {
        /** 获得特殊奖励 */
        AcquireSepecialAwardLayer : new PrefabFileInfo(
            'prefab/popup/AcquireSepecialAwardLayer'
            , BUNDLE_SMALL_NAME.shopGameBundle
        ),
        /** 空白屏蔽点击层 */
        EmptyTouchLuckLayer : new PrefabFileInfo(
            'gameCommon/prefab/basic/EmptyTouchLuckLayer'
            , BUNDLE_SMALL_NAME.gameBundle
        ),

        /**  进入界面事件  */
        EnterLayerEventShow : new PrefabFileInfo(
            'prefab/EnterLayerEventShow'
            , BUNDLE_SMALL_NAME.eventGameBundle
        ),
        /**  进入界面事件  */
        EnterLayerEventShow2 : new PrefabFileInfo(
            'prefab/EnterLayerEventShow2'
            , BUNDLE_SMALL_NAME.eventGameBundle
        ),
        /**  游戏结束事件界面  */
        GameEndEventLayer : new PrefabFileInfo(
            'prefab/GameEndEventLayer'
            , BUNDLE_SMALL_NAME.eventGameBundle
        ),
        /**  获得物品界面  */
        EventGetGoodsLayer : new PrefabFileInfo(
            'prefab/EventGetGoodsLayer'
            , BUNDLE_SMALL_NAME.eventGameBundle
        ),

        /** 考试 */
        ExamLayer : new PrefabFileInfo(
            'prefab/ExamLayer'
            , BUNDLE_SMALL_NAME.examBundle
        ),
        ExamSuccessLayer : new PrefabFileInfo(
            'prefab/ExamSuccessLayer'
            , BUNDLE_SMALL_NAME.examBundle
        ),

        /** 言出法随合成界面 */
        SuperPowerCompoundLayer : new PrefabFileInfo(
            'prefab/SuperPowerCompoundLayer'
            , BUNDLE_SMALL_NAME.superPowerBundle
        ),

        /** 言出法随选择界面 */
        SuperPowerSelectLayer : new PrefabFileInfo(
            'prefab/SuperPowerSelectLayer'
            , BUNDLE_SMALL_NAME.superPowerBundle
        ),

        /** 穿越时空入口 */
        ThruTimeAccessLayer : new PrefabFileInfo(
            'prefab/ThruTimeAccessLayer'
            , BUNDLE_SMALL_NAME.thruTimeAccess
        ),
        /** 跳过剧情 */
        SkipPlotSelectLayer : new PrefabFileInfo(
            'prefab/SkipPlotSelectLayer'
            , BUNDLE_SMALL_NAME.skipPlotBundle
        ),

            
        /** 断案 */
        /** 模式选择 */
        SettlLawSuitModelSelectLayer : new PrefabFileInfo(
            'prefab/SettlLawSuitModelSelectLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),
        /** 案件选择 */
        SettlLawSuitSelectLayer : new PrefabFileInfo(
            'prefab/SettlLawSuitSelectLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),

        /** 特殊案件成功界面  */
        SettleLawsuitSpecialSuccessLayer : new PrefabFileInfo(
            'prefab/special/SettleLawsuitSpecialSuccessLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),
        /** 特殊案件失败界面  */
        SettleLawsuitSpecialLoseLayer : new PrefabFileInfo(
            'prefab/special/SettleLawsuitSpecialLoseLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),
        /** 特殊案件模式 */
        SettleLawsuitSpecialLayer : new PrefabFileInfo(
            'prefab/special/SettleLawsuitSpecialLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),

        /** 主要案件模式 */
        SettleLawsuitMainLayer : new PrefabFileInfo(
            'prefab/main/SettleLawsuitMainLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),
         /** 主要案件成功界面  */
         SettleLawsuitMainSuccessLayer : new PrefabFileInfo(
            'prefab/main/SettleLawsuitMainSuccessLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),
        /** 主要案件失败界面  */
        SettleLawsuitMainLoseLayer : new PrefabFileInfo(
            'prefab/main/SettleLawsuitMainLoseLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),
            
        /** 初级案件模式 */
        SettleLawsuitPrimaryLayer : new PrefabFileInfo(
            'prefab/primary/SettleLawsuitPrimaryLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),
        /** 初级案件成功界面  */
        SettleLawsuitPrimarySuccessLayer : new PrefabFileInfo(
            'prefab/primary/SettleLawsuitPrimarySuccessLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),
        /** 初级案件失败界面  */
        SettleLawsuitPrimaryLoseLayer : new PrefabFileInfo(
            'prefab/primary/SettleLawsuitPrimaryLoseLayer'
            , BUNDLE_SMALL_NAME.settleLawsuitBundle
        ),

        /** 
         * 抽奖 
        */
        /** 刮刮乐选择界面 */
        LotterySelectLayer : new PrefabFileInfo(
            'prefab/LotterySelectLayer'
            , BUNDLE_SMALL_NAME.shopGameBundle
        ),
        /**  */
        ShopTouchCardSelectLayer : new PrefabFileInfo(
            'prefab/ShopTouchCardSelectLayer'
            , BUNDLE_SMALL_NAME.shopGameBundle
        ),
       /** 刮刮乐 */
       shopNewGGL1Prefab : new PrefabFileInfo(
            'prefab/newGGL/shopNewGGL1Prefab'
            , BUNDLE_SMALL_NAME.shopGameBundle
        ),
       /** 雀神刮刮乐 */
       MahjongLayer : new PrefabFileInfo(
            'prefab/mahjong/MahjongLayer'
            , BUNDLE_SMALL_NAME.lotteryBundle
        ),
       /** 金花大乱斗 */
       GoldFlowerLayer : new PrefabFileInfo(
            'prefab/goldFlower/GoldFlowerLayer'
            , BUNDLE_SMALL_NAME.lotteryBundle
        ),
       /** 名堂刮刮乐 */
       MingTangLayer : new PrefabFileInfo(
            'prefab/mingTang/MingTangLayer'
            , BUNDLE_SMALL_NAME.lotteryBundle
        ),
       /** 橙意满满 */
       ChengYiManManLayer : new PrefabFileInfo(
            'prefab/chenYi/ChengYiManManLayer'
            , BUNDLE_SMALL_NAME.lotteryBundle
        ),
       /** 快乐中中中 */
       HappyWinLayer : new PrefabFileInfo(
            'prefab/happyWin/HappyWinLayer'
            , BUNDLE_SMALL_NAME.lotteryBundle
        ),

        /** 选牌挑战 */
        ChooseCardChallengeLayer : new PrefabFileInfo(
            'prefab/chooseCardChallenge/ChooseCardChallengeLayer'
            , BUNDLE_SMALL_NAME.touchCardBundle
        ),
        /** 摸牌挑战 */
        TouchCardChallengeLayer : new PrefabFileInfo(
            'prefab/touchCardChallenge/TouchCardChallengeLayer'
            , BUNDLE_SMALL_NAME.touchCardBundle
        ),


        /**
         * 军事
         */
        /** 招募 */
        MilitaryRecruitOfficerLayer : new PrefabFileInfo(
            'prefab/recruit/MilitaryRecruitOfficerLayer'
            , BUNDLE_SMALL_NAME.militaryBundle
        ),
        MilitaryRecruitOfficerPopLayer : new PrefabFileInfo(
            'prefab/recruit/MilitaryRecruitOfficerPopLayer'
            , BUNDLE_SMALL_NAME.militaryBundle
        ),

        /** 皇宫 */
        PalaceLayer : new PrefabFileInfo(
            'prefab/PalaceLayer'
            , BUNDLE_SMALL_NAME.palaceBundle
        ),

        /** 商船 */
        ShipListLayer : new PrefabFileInfo(
            'prefab/ship/ShipListLayer'
            , BUNDLE_SMALL_NAME.investStockGameBundle
        ),

        /**
         * 地图
         */
        /** 地图 */
        MilitaryMapLayer : new PrefabFileInfo(
            'prefab/map/MilitaryMapLayer'
            , BUNDLE_SMALL_NAME.militaryBundle
        ),
        /** 地图 */
        MilitaryMapPopLayer : new PrefabFileInfo(
            'prefab/map/MilitaryMapPopLayer'
            , BUNDLE_SMALL_NAME.militaryBundle
        ),
        /** 城池信息 */
        MilitaryCityInfoLayer : new PrefabFileInfo(
            'prefab/map/MilitaryCityInfoLayer'
            , BUNDLE_SMALL_NAME.militaryBundle
        ),
        /** 我的武将 */
        MilitaryMyOfficerLayer : new PrefabFileInfo(
            'prefab/map/MilitaryMyOfficerLayer'
            , BUNDLE_SMALL_NAME.militaryBundle
        ),
        /** 选择武将镇守界面 */
        MilitarySelectOfficerLayer : new PrefabFileInfo(
            'prefab/map/MilitarySelectOfficerLayer'
            , BUNDLE_SMALL_NAME.militaryBundle
        ),
        /** 收益 */
        MilitaryEarningLayer : new PrefabFileInfo(
            'prefab/map/MilitaryEarningLayer'
            , BUNDLE_SMALL_NAME.militaryBundle
        ),


        /** 府邸 */
        MansionLayer : new PrefabFileInfo(
            'prefab/MansionLayer'
            , BUNDLE_SMALL_NAME.mansionBundle
        ),
        /** 典当 */
        PawnLayer : new PrefabFileInfo(
            'prefab/PawnLayer'
            , BUNDLE_SMALL_NAME.pawnShopGameBundle
        ),
        PawnRansomGoodsLayer : new PrefabFileInfo(
            'prefab/ransom/PawnRansomGoodsLayer'
            , BUNDLE_SMALL_NAME.pawnShopGameBundle
        ),
        /** 比武招亲 */
        MatchMiaiLayer : new PrefabFileInfo(
            'prefab/MatchMiaiLayer'
            , BUNDLE_SMALL_NAME.matchMiaiBundle
        ),
        /**  */
        MatchMiaiBuyEquipLayer : new PrefabFileInfo(
            'prefab/MatchMiaiBuyEquipLayer'
            , BUNDLE_SMALL_NAME.matchMiaiBundle
        ),
        /** 选择武器  */
        MatchMiaiWeaponSelect : new PrefabFileInfo(
            'prefab/MatchMiaiWeaponSelect'
            , BUNDLE_SMALL_NAME.matchMiaiBundle
        ),
        
        /**  */
        OpenOreCollectLayer : new PrefabFileInfo(
            'openOreGame/OpenOreCollectLayer'
            , BUNDLE_SMALL_NAME.openOreGameBundle
        ),

        /**河道 */
        WaterCourseLayer : new PrefabFileInfo(
            'waterCourse',
            BUNDLE_SMALL_NAME.waterCourse
        ),
        
        /**脚气治疗开始界面 */
        healBeriberiStartLayer : new PrefabFileInfo(
            "healBeriberiGame/prefab/healBeriberiStartPage",
            BUNDLE_SMALL_NAME.waterCourse
        ),
        /** 丘比特界面2 */
        CupidHelp2Layer : new PrefabFileInfo(
            "cupid2/prefab/CupidHelp2Layer",
            BUNDLE_SMALL_NAME.waterCourse
        ),

        /** 丘比特界面2 */
        CupidHelp3Layer : new PrefabFileInfo(
            "cupid3/prefab/CupidHelp3Layer",
            BUNDLE_SMALL_NAME.waterCourse
        ),

        HelpWifeLayer1 : new PrefabFileInfo(
            "helpWife/prefab/HelpWifeLayer1",
            BUNDLE_SMALL_NAME.waterCourse
        ),

        /**脚气治疗游戏界面 */
        healBeriberiGameLayer : new PrefabFileInfo(
            "healBeriberiGame/prefab/healBeriberiGame",
            BUNDLE_SMALL_NAME.waterCourse
        ),
        /**套牛游戏界面 */
        takeCowGameLayer:new PrefabFileInfo(
        "prefab/takeCow/takeCowPage",
        BUNDLE_SMALL_NAME.takeCow),

        /**套牛游戏界面 */
        takeCowGameAddRopeLayer:new PrefabFileInfo(
        "prefab/takeCow/takeCowAddRopePage",
        BUNDLE_SMALL_NAME.takeCow),

        /**拯救贵妃 */
        archeryGameLayer:new PrefabFileInfo(
            "archeryGame",
            BUNDLE_SMALL_NAME.archeryArrow
        ),
        /**拯救贵妃失败界面 */
          archeryLoseLayer:new PrefabFileInfo(
            "archeryLosePage",
            BUNDLE_SMALL_NAME.archeryArrow
        ),

        /**拯救贵妃开始界面 */
        archeryStartLayer:new PrefabFileInfo(
            "saveArcheryStartPage",
            BUNDLE_SMALL_NAME.archeryArrow
        ),

        /**李白对诗第一个界面 */
        libaiOneLayer:new PrefabFileInfo(
            "level66/Level_66",
            BUNDLE_SMALL_NAME.antiphonalVerse
        ),

        /**李白对诗第二个界面 */
        libaiTwoLayer:new PrefabFileInfo(
            "level67/Level_67",
            BUNDLE_SMALL_NAME.antiphonalVerse
        ),

        /** 夸贵妃 */
        BoastGuiFeiLayer: new PrefabFileInfo(
            "prefab/BoastGuiFeiLayer",
            BUNDLE_SMALL_NAME.boastGuiFei
        ),
        /** 打劫匪 */
        HitRobLayer: new PrefabFileInfo(
            "prefab/HitRobLayer",
            BUNDLE_SMALL_NAME.hitRobBundle
        ),
        /** 贵妃 */
        GuiFeiLayer: new PrefabFileInfo(
            "prefab/GuiFeiLayer",
            BUNDLE_SMALL_NAME.guiFeiBundle
        ),
        
        /** 出售 */
        PacksackSellLayer: new PrefabFileInfo(
            "backpack/PacksackSellLayer",
            BUNDLE_SMALL_NAME.backPackGameBundle
        ),
        /** 押镖1 */
        EscortGoods1Layer: new PrefabFileInfo(
            "prefab/EscortGoods1Layer",
            BUNDLE_SMALL_NAME.escortGoods1Bundle
        ),

        /** 押镖失败界面 */
        dartLosePage: new PrefabFileInfo(
            "prefab/dartLosePage",
            BUNDLE_SMALL_NAME.dartGameBundle
        ),

        /**押镖游戏 */
        dartGame:new PrefabFileInfo(
            "prefab/dartGame",
            BUNDLE_SMALL_NAME.dartGameBundle
        ),

        /**押镖开始界面 */
        dartStartPage:new PrefabFileInfo(
            "prefab/dartStartPannel",
            BUNDLE_SMALL_NAME.dartGameBundle
        ),

        /**押镖胜利界面 */
        dartWinPage:new PrefabFileInfo(
            "prefab/dartWinPage",
            BUNDLE_SMALL_NAME.dartGameBundle
        ),

        /**任务 */
        TaskLayer: new PrefabFileInfo(
            "prefab/TaskLayer",
            BUNDLE_SMALL_NAME.taskBundle
        ),
        /** 果园 */
        OrchardSelectLayer: new PrefabFileInfo(
            "prefab/OrchardSelectLayer",
            BUNDLE_SMALL_NAME.orchardBundle
        ),

        /** 获得物品提示 */
        BravoGetGoodsLayer: new PrefabFileInfo(
            "gameCommon/prefab/basic/BravoGetGoodsLayer",
            BUNDLE_SMALL_NAME.gameBundle
        ),

        /**套牛合成界面 */
        takeCowSynthesisPage:new PrefabFileInfo(
            "prefab/takeCow/takeCowSynthesisPage",
            BUNDLE_SMALL_NAME.takeCow
        ),

        /**套牛合成成功界面 */
        takeCowSynthesisSuccessPage:new PrefabFileInfo(
            "prefab/takeCow/takeCowSynthesisSuccessPage",
            BUNDLE_SMALL_NAME.takeCow
        ),

        /**特大喜讯 */
        outSizePage:new PrefabFileInfo(
            "prefab/outsizePage",
            BUNDLE_SMALL_NAME.normalMode
        ),
        
        /**策划的馈赠 */
        feedBackPage:new PrefabFileInfo(
            "prefab/feedbackPage",
            BUNDLE_SMALL_NAME.normalMode
        )
    }
}